import React, { FC } from 'react';
import { View } from 'react-native';
import { useSelector } from 'react-redux';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { updateHeaderConfig, selectNcFiles, selectNcFileId } from '@reducers/details';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import { loadSingleBatch } from '@reducers/batch';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { NCFileTraceabilityContent } from '@v2/pages/common/components/NCFileTraceabilityContent';
import { DETAILS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

const ProductionOrderDetailsNCFileTraceability: FC = () => {
  const dispatch = useAppDispatch();
  const ncFiles = useSelector(selectNcFiles);
  const ncFileId = useSelector(selectNcFileId);
  const title = useTitle();

  useProductionOrderDetails({
    productionOrdersSearch: (params) => dispatch(productionOrdersSearch(params)),
    getNCFilesByProductionOrderId: (id, filters) => dispatch(getNCFilesByProductionOrderId(id, filters)),
    getProductionBatchByProductionOrderId: (params) => dispatch(getProductionBatchByProductionOrderId(params)),
    loadSingleBatch: (batchId) => dispatch(loadSingleBatch(batchId)),
    updateHeaderConfig: (config) => dispatch(updateHeaderConfig(config)),
    getAllNcFiles: true,
  });

  // Production order can link many NC files — anchor the graph on the first of the list.
  const anchorNcFileId = ncFiles.data?.[0]?.ncFileId ?? ncFileId ?? null;

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <View style={DETAILS_SCREENS_CONTAINER_STYLES}>
        <NCFileTraceabilityContent ncFileId={anchorNcFileId} resolving={!ncFiles.wasLoaded} />
      </View>
    </DetailsPageWrapper>
  );
};

export { ProductionOrderDetailsNCFileTraceability };
